module.exports = __webpack_public_path__ + "720473c2bf9fa2beed7262ff4c619704.jpg";